import React, {Component} from "react";

class UserSummaryDetails extends Component {
    render(){
        return(
            <div>
               <div>
                    <div>

                    </div>
                    <span>123,456</span>
               </div>
                <span>See More</span>
            </div>
        )
    }
}

export default UserSummaryDetails;